import Base64 from './base64.js';

/**
 * A companion to obfuscate.js
 */
String.prototype.clarify = function () {
    return JSON.parse(Base64.decode(this));
};
